import React from "react";
import styles from "./Folders.module.css";

function Folder({ title, setOpenFolderName, clicked, setClicked }) {
  const folderClick = (e) => {
    e.stopPropagation();
    setClicked(title);
  };
  return (
    <div
      className={
        clicked === title
          ? `${styles.folder} ${styles.clicked}`
          : `${styles.folder}`
      }
      onClick={(e) => folderClick(e)}
      onDoubleClick={(e) => {
        e.stopPropagation();
        setOpenFolderName(title);
      }}
    >
      <img src="folder.png" alt={title} />
      <span>{title}</span>
    </div>
  );
}

export default Folder;
